import React, { type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./card-content.module.scss";

const cx = c.bind(styles);

const rootClassName = "purpur-card-content";

type CardContentProps = Omit<BaseProps, "children"> & {
  /**
   * The child elements of the content (React.ReactNode)
   */
  children: ReactNode;
};

export const CardContent = ({
  ["data-testid"]: dataTestId = "purpur-card-content",
  children,
  className,
  ...props
}: CardContentProps) => {
  return (
    <div className={cx(rootClassName, className)} data-testid={dataTestId} {...props}>
      {children}
    </div>
  );
};
